import React from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import { Box, Avatar, Container } from '@material-ui/core'
import { Rating } from '@material-ui/lab'

//Components
import Search from '../Search/Search'

//HELPERS
import { replaceStringSpaces, addArrayItems } from '../../utils/helpers'

const ModelWithSearchBar = ({
  name,
  agencyKey,
  logo,
  bannerImage,
  experienceName,
  experienceCategory,
  reviews,
  isMock,
  hide,
}) => {
  const history = useHistory()
  const { slug } = useParams()
  const useStyles = makeStyles((theme) => ({
    bannerBg: {
      backgroundImage: `linear-gradient(0deg, rgba(160, 118, 236, 0.7) 19%, rgba(103, 58, 183, 0.7) 83%), url(${bannerImage})`,
      //  width: '100%',
      backgroundSize: 'cover',
      backgroundPosition: '0% 50%',
    },
  }))
  const classes = useStyles()

  const handleReviewRating = () => {
    const ratingArray = reviews.map((review) => review.rating)

    const totalRating = addArrayItems(ratingArray)

    const average = (totalRating / reviews.length).toFixed(1)

    return average
  }

  const handleRedirect = () => {
    const url = window.location.pathname.split('/')
    return history.push('/' + url[1])
    // if (slug) {
    //   return history.push(`/marketplace/${slug}/${agencyKey}`)
    // } else {
    //   return history.push(`/${agencyKey}`)
    // }
  }

  return (
    <>
      <Box
        paddingY={3}
        pt={!hide ? 6 : 12}
        pb={!hide ? 6 : 12}
        mb={3}
        className={classes.bannerBg}
      >
        <Container>
          <Box display="flex" alignItems="center">
            <Avatar
              alt="agency-logo"
              src={logo ? logo : ''}
              loading="eager"
              style={{ width: '145px', height: '145px' }}
            />
            <Box ml={3}>
              <h1
                style={{ cursor: 'pointer', margin: 0, color: 'white' }}
                onClick={() => {
                  agencyKey && handleRedirect()
                }}
              >
                {name ? name.replace(/^\w/, (c) => c.toUpperCase()) : ''}
              </h1>
              {experienceName && (
                <h2 style={{ cursor: 'pointer', margin: 0, color: 'white' }}>
                  {experienceName}, {experienceCategory}
                </h2>
              )}
              {reviews && reviews.length ? (
                <Box display="flex" alignItems="center">
                  <Rating
                    name="average-rating"
                    readOnly
                    precision={0.5}
                    value={handleReviewRating()}
                  />
                  <span>
                    {handleReviewRating()}{' '}
                    <small style={{ color: 'white' }}>
                      ({reviews.length} reseñas)
                    </small>
                  </span>
                </Box>
              ) : null}
            </Box>
          </Box>
        </Container>
        {/*     {!hide && (
          <Box marginX={3}>
            <Search isMock={isMock} size="small" />
          </Box>
        )} */}
      </Box>

      {/*   <Container>
        <Box display="flex" alignItems="center">
          <Avatar
            alt="agency-logo"
            src={logo ? logo : ''}
            style={{ width: '145px', height: '145px' }}
          />
          <Box ml={3}>
            <h1
              style={{ cursor: 'pointer', margin: 0 }}
              onClick={() => {
                agencyKey && handleRedirect()
              }}
            >
              {name ? name.replace(/^\w/, (c) => c.toUpperCase()) : ''}
            </h1>
            {experienceName && (
              <h2 style={{ cursor: 'pointer', margin: 0 }}>{experienceName}</h2>
            )}
            {reviews && reviews.length ? (
              <Box display="flex" alignItems="center">
                <Rating
                  name="average-rating"
                  readOnly
                  precision={0.5}
                  value={handleReviewRating()}
                />
                <span>
                  {handleReviewRating()}{' '}
                  <small>({reviews.length} reseñas)</small>
                </span>
              </Box>
            ) : null}
          </Box>
        </Box>
      </Container> */}
    </>
  )
}

export default ModelWithSearchBar
